import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import '@polymer/polymer/lib/utils/debounce.js';
import { ModelSharingLink } from '../sharing-link/model-sharing-link';
/**
 * `model-loader`
 * Pole application view element
 *
 * @customElement
 * @polymer
 * @demo demo/index.html
 */
class ModelLoader extends PolymerElement {
  static get is() {
    return 'model-loader';
  }
  static get properties() {
    return {
      items: {
        type: Array
      },
      companyId: {
        type: String
      },
      observers: {
        type: Object,
        value: () => ({})
      }
    };
  }
  static get observers() {
    return ['getData(items, companyId)'];
  }
  async getData(items, companyId) {
    const validUserGroup = this.userGroup && this.userGroup != '_custom_auth';
    //Authenticated links should not update the model space, but if the user is authenticated and there is a company id, we can check if the shared model space is up to date and update it if needed
    if (validUserGroup && companyId) {
      const sharingLinkId = await FirebaseWorker.ref(`photoheight/company_space/${companyId}/sharing_link_id`)
        .once('value')
        .then((s) => s.val());
      const modelOwner = await FirebaseWorker.ref(`photoheight/company_space/${companyId}/model_owner`)
        .once('value')
        .then((s) => s.val());
      let upToDate = true;
      let sharingLink;
      let autoUpdate = false;
      if (sharingLinkId)
        sharingLink = await FirebaseWorker.ref(`photoheight/company_space/${modelOwner}/sharing_links/model_sharing/${sharingLinkId}`)
          .once('value')
          .then((s) => s.val());
      if (sharingLink) {
        const metadata = sharingLink.metadata || {};
        upToDate = metadata?.up_to_date;
        autoUpdate = metadata?.auto_sync;
      }
      if (!upToDate && autoUpdate) {
        await ModelSharingLink.updateSharedModel({
          linkId: sharingLinkId,
          companyId: modelOwner
        }).catch(() => {
          console.warn('Failed to update shared model space');
        });
      }
    }
    if (items && items.length > 0) {
      for (var property in this.observers) {
        this.observers[property].models.forEach((model) => {
          model.ref.off('value', model.listener);
        });
      }
      this.observers = {};
      if (companyId) {
        items.forEach((item) => {
          let property = this.formatProperty(item);
          if (!this[property]) this._createNotifyingProperty(property);
          this.observers[property] = { initializing: true, models: [] };
          let observer = { ref: FirebaseWorker.ref(`photoheight/company_space/${companyId}/models/${item}`) };
          this.observers[property].models.push(observer);
          observer.listener = observer.ref.on('value', (s) => {
            observer.value = s.val();
            this.computeItem(property);
          });
          this.observers[property].initializing = false;
          this.computeItem(property);
        });
      } else {
        items.forEach((item) => {
          this[this.formatProperty(item)] = null;
        });
      }
    }
  }
  formatProperty(str) {
    if (typeof str !== 'string') {
      return str;
    }
    if (str == 'attributes') return 'otherAttributes';
    str = str.replace(/\//g, '_');
    return str
      .replace(/_(.)/g, function (match, group1) {
        return group1.toUpperCase();
      })
      .trim();
  }
  computeItem(property) {
    if (!this.observers[property].initializing && this.observers[property].models.every((x) => typeof x.value != 'undefined')) {
      let data = {};
      this.observers[property].models.forEach((observer) => {
        this.assignData(data, observer.value, property);
      });
      this[property] = data;
    }
  }
  assignData(target, source, property) {
    for (let key in source) {
      if (property == 'buttonGroups' || property == 'inputModelGroups') {
        target[key] = target[key] || {};
        this.assignData(target[key], source[key]);
      } else {
        if (source[key] == '_remove') {
          delete target[key];
        } else {
          target[key] = source[key];
        }
      }
    }
  }
}
window.customElements.define(ModelLoader.is, ModelLoader);
